import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteFreightClaimAttachmentsCall,
  postUpdateDSDData,
  uploadFreightClaimAttachmentsCall
} from "src/api/sp";
import { UploadAttachmentFile } from "../CreateInventoryAdjustment/interface";

export const editDSDData = createAsyncThunk("editDSDData", (payload: any) =>
  postUpdateDSDData(payload)
);

export const editDSDUploadAttachments = createAsyncThunk(
  "editDSDUploadAttachments",
  (dsdAttachmentPayload: UploadAttachmentFile) =>
    uploadFreightClaimAttachmentsCall(dsdAttachmentPayload)
);

export const deleteDSDAttachments = createAsyncThunk(
  "deleteDSDAttachments",
  (filePath: string) => {
    deleteFreightClaimAttachmentsCall(filePath);
  }
);

const initialState: any = {
  notes: "",
  attachments: [],
  blockNavigation: true,
  loading: false
};

const editDSDSlice = createSlice({
  name: "editDSD",
  initialState,
  reducers: {
    updateDSDNavigationBlocking(state: any, action: any) {
      state.blockNavigation = action.payload;
    },
    updateDSDNotes(state: any, action: any) {
      const notes = action.payload;
      state.notes = notes;
    },
    updateDSDAttachment(
      state: any,
      action: {
        payload: { fileName: string; fileURL: string; fileType: string };
      }
    ) {
      state.attachments.push(action.payload);
    },
    removeDSDAttachment(state: any, action: { payload: number }) {
      const filterAttachments = state.attachments.filter(
        (_item: any, itemIndex: number) => itemIndex !== action?.payload
      );
      state.attachments = filterAttachments;
    },
    resetDSDData() {
      return initialState;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(editDSDData.pending, (state) => {
        state.loading = true;
      })
      .addCase(editDSDData.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editDSDData.rejected, (state) => {
        state.loading = false;
      });
  }
});

export const {
  updateDSDNotes,
  updateDSDNavigationBlocking,
  updateDSDAttachment,
  removeDSDAttachment,
  resetDSDData
} = editDSDSlice.actions;

export const selectBlockDSDNavigation = (state: any) =>
  state.editDSD.blockNavigation;

export const selectDSDNotes = (state: any) => state.editDSD.notes;

export const selectDSDAttachments = (state: any) => state.editDSD?.attachments;

export default editDSDSlice.reducer;
